import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDate(date: Date): string {
  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(date);
}

export function getColorLuminance(hslString: string): number {
  // Extract H, S, L values from HSL string like "220 70% 50%"
  const match = hslString.match(/(\d+)\s+(\d+)%\s+(\d+)%/);
  if (!match) return 0.5; // fallback to medium luminance
  
  const [, h, s, l] = match.map(Number);
  return l / 100; // Convert percentage to decimal
}

export function getContrastingColor(hslString: string): string {
  const luminance = getColorLuminance(hslString);
  // Use white text on dark backgrounds (< 50% luminance), black on light backgrounds
  return luminance < 0.5 ? "#ffffff" : "#000000";
}
